import $ from "jquery";

var selectedVariant = "";
var productVariants = [];

const selectVariant = function(e) {
    e.preventDefault();
    var dataOption      = $(this).data('option');
    var dataValue       = $(this).data('value');

    console.log("selectVariant",dataOption,dataValue);
    
    var productDiv              = document.getElementById('Product');
    var selectedVariantID       = productDiv.getAttribute('data-variant');
    var selectedVariant = productVariants.find(function(element) {
        return element.id === parseInt(selectedVariantID, 10);
    });

    if (dataOption == "1") {
        console.log("variant select 1", dataValue, selectedVariant.option2);
        var selectedVariant = productVariants.find(function(element) {
            return (element.option1 === dataValue) && (element.option2 === selectedVariant.option2);
        });
    }
    if (dataOption == "2") {
        console.log("variant select 2", dataValue, selectedVariant.option1);
        var selectedVariant = productVariants.find(function(element) {
            return (element.option1 === selectedVariant.option1) && (element.option2 === dataValue);
        });
    }

    if (!selectedVariant) {
        console.log("selectedVariant not found");
        if (dataOption == "1") {
            var selectedVariant = productVariants.find(function(element) {
                return (element.option1 === dataValue);
            });
        }
        if (dataOption == "2") {
            var selectedVariant = productVariants.find(function(element) {
                return (element.option2 === dataValue);
            });
        }
        console.log("selectedVariant id",selectedVariant.id);
    }

    var currentUrl = window.location.href;
    var baseUrl = currentUrl.split('?')[0];
    window.location.href = baseUrl + '?variant='+selectedVariant.id;

    

  }


export const initProduct = function() {

    var productVariantsElement = document.getElementById("productVariants");
    if (productVariantsElement) {
        
        var productVariantsData = productVariantsElement.textContent;
        productVariants     = JSON.parse(productVariantsData);

        var productDiv          = document.getElementById('Product');
        var selectedVariantID     = productDiv.getAttribute('data-variant');
        var selectedVariant = productVariants.find(function(element) {
            return element.id === parseInt(selectedVariantID, 10);
        });


        $('.variant-button').each(function(index, element) {

            var dataOption = $(this).data('option');
            var dataValue = $(this).data('value');

            if (dataOption=="1" && selectedVariant.option1 == dataValue) {
                $(this).addClass("active");
            }
            if (dataOption=="2" && selectedVariant.option2 == dataValue) {
                $(this).addClass("active");
            }
            if (dataOption=="3" && selectedVariant.option3 == dataValue) {
                $(this).addClass("active");
            }
        });

        $('.variant-button').on('click', selectVariant);

    }
  
 
 };